 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"application": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"application": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"pledge-against-antisemitism-countries":"pledge-against-antisemitism-countries","vendors~livecasts-stream":"vendors~livecasts-stream","livecasts-stream":"livecasts-stream","vendors~mena-list~speakers-bureau-presentations":"vendors~mena-list~speakers-bureau-presentations","mena-list":"mena-list","speakers-bureau-presentations":"speakers-bureau-presentations","admin-settings-panel":"admin-settings-panel","un-antisemitism-speakers":"un-antisemitism-speakers","un-antisemitism-stream":"un-antisemitism-stream","vendors~communities":"vendors~communities","communities":"communities","vendors~driver":"vendors~driver"}[chunkId]||chunkId) + "-" + {"0":"fc7b24532196c2f7699d","1":"f12f19d79359c222d652","2":"9fe27a48413cce3c5efb","3":"97ee18eaa7371a14f58d","4":"e2597e1c8f0c87908c39","5":"a0e19e37d4d4ac969479","6":"d4cef7626a40ccef7db9","7":"0b19515ead6b07b57684","9":"d3f117baf6462000c49b","10":"3b82f4f806cf146c097d","12":"591b058a3e2b568b6c7f","13":"ca0f79f1e895d9db6618","14":"fd08cb1bdfd223a0ac43","15":"de10b2d5c2c113f3ccb9","16":"3ce2c8edef6616019ff5","17":"71f9d5197c1079aae678","18":"92dc8235a1816e9be19a","19":"cd1fc4085c430fe4d095","20":"6f2fabe71e223c82d925","21":"4cc0e4036850a79c8ebb","22":"de2444e93160c6bcc872","23":"a1fe7ad77cf1db9bdabb","24":"221977b6adca8f7b5c59","25":"73efa60792653a0d6ff2","26":"451e25985eee7920a133","27":"57caf06204cdc989af5a","28":"ea282f1676b85f248a5c","29":"f155c0dd348fabb9c368","30":"8ed195f26b12704ebcc7","31":"0955e04826141731e091","32":"9b54034ee011dab71723","33":"433901154acc65f63bcd","34":"d47e3bedaf05fe88bbca","35":"8bca1573a34dc70133c2","36":"0015ab30b1bf73ad47c9","37":"92db90591441e9848e84","38":"f291a1388085fee2477c","39":"05ee5eb775cd833bf7bc","40":"8bab182881d1c02aba0e","41":"6700838c0f11322109ee","42":"7750ab10579f07f552af","43":"f3fe776e66398996cba5","44":"3ef4831aa9a2a05e484d","45":"f9aed6457289d78a8481","46":"d6777068427e57a98271","47":"60f3a2221716e552a582","48":"b2e3f1a8164665dc97d6","49":"07f069b90d3c6bb60028","50":"050946ccc945541f6850","51":"5970d885722c9f08a15d","52":"d36cea37c43e479e62e1","53":"725ea54e71e6ecc003f8","54":"e50a44d0fc4454ac5699","55":"b1808b429e08cb379cdd","56":"5a99f8bb5718322c049e","57":"74d683426bae656787ec","58":"7b101f1123254d0559dd","59":"f5e4973eba7a65ea4a33","60":"7a9cdc1dcc43e7d4d730","61":"c879196882799149a54b","62":"aee014ae653aa408620d","63":"8d6fbcf6af9e6c97f5ee","64":"b0813fe5780f86432a69","65":"6b543cb3b26322ea2f81","66":"1e915cef08f3a7d7f648","67":"1275cd953057edff64ee","68":"4179b547b1e90146a4a2","69":"980dfa9169c8d973b0d1","70":"0f4b98f42f6469a1250b","71":"0e2b856b8d0bc30e8539","72":"885e7cee31787816a536","pledge-against-antisemitism-countries":"4acf527af99be57c041d","vendors~livecasts-stream":"976386b8856f6ba35684","livecasts-stream":"f1197a2e5e561b2a9a83","vendors~mena-list~speakers-bureau-presentations":"075fefeff9a52dcd9765","mena-list":"678cb1e52ae568d42b6f","speakers-bureau-presentations":"dabd9091b43274f51dcd","admin-settings-panel":"e0111df573aafd0dc20a","un-antisemitism-speakers":"7b45e31b50b0c45cc460","un-antisemitism-stream":"b7f6c11f4e896f156e2c","vendors~communities":"e783610e62518d29500b","communities":"0b02a69889e1e2a3dad2","vendors~driver":"63b569eb5a42464ca02e"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"9":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"27":1,"pledge-against-antisemitism-countries":1,"livecasts-stream":1,"mena-list":1,"speakers-bureau-presentations":1,"admin-settings-panel":1,"un-antisemitism-stream":1,"vendors~communities":1,"communities":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"pledge-against-antisemitism-countries":"pledge-against-antisemitism-countries","vendors~livecasts-stream":"vendors~livecasts-stream","livecasts-stream":"livecasts-stream","vendors~mena-list~speakers-bureau-presentations":"vendors~mena-list~speakers-bureau-presentations","mena-list":"mena-list","speakers-bureau-presentations":"speakers-bureau-presentations","admin-settings-panel":"admin-settings-panel","un-antisemitism-speakers":"un-antisemitism-speakers","un-antisemitism-stream":"un-antisemitism-stream","vendors~communities":"vendors~communities","communities":"communities","vendors~driver":"vendors~driver"}[chunkId]||chunkId) + "-" + {"0":"31d6cfe0","1":"31d6cfe0","2":"f239d2c7","3":"31d6cfe0","4":"31d6cfe0","5":"31d6cfe0","6":"31d6cfe0","7":"31d6cfe0","9":"76ba5901","10":"31d6cfe0","12":"3cfff33a","13":"a8b3fe7e","14":"9e21343f","15":"21d50dff","16":"deb7271f","17":"436748b7","18":"a4b7f204","19":"f9ac71fc","20":"5aef26e5","21":"e78ee872","22":"ea7770ed","23":"7b4edb8d","24":"31d6cfe0","25":"31d6cfe0","26":"31d6cfe0","27":"b66f83e3","28":"31d6cfe0","29":"31d6cfe0","30":"31d6cfe0","31":"31d6cfe0","32":"31d6cfe0","33":"31d6cfe0","34":"31d6cfe0","35":"31d6cfe0","36":"31d6cfe0","37":"31d6cfe0","38":"31d6cfe0","39":"31d6cfe0","40":"31d6cfe0","41":"31d6cfe0","42":"31d6cfe0","43":"31d6cfe0","44":"31d6cfe0","45":"31d6cfe0","46":"31d6cfe0","47":"31d6cfe0","48":"31d6cfe0","49":"31d6cfe0","50":"31d6cfe0","51":"31d6cfe0","52":"31d6cfe0","53":"31d6cfe0","54":"31d6cfe0","55":"31d6cfe0","56":"31d6cfe0","57":"31d6cfe0","58":"31d6cfe0","59":"31d6cfe0","60":"31d6cfe0","61":"31d6cfe0","62":"31d6cfe0","63":"31d6cfe0","64":"31d6cfe0","65":"31d6cfe0","66":"31d6cfe0","67":"31d6cfe0","68":"31d6cfe0","69":"31d6cfe0","70":"31d6cfe0","71":"31d6cfe0","72":"31d6cfe0","pledge-against-antisemitism-countries":"9f33977b","vendors~livecasts-stream":"31d6cfe0","livecasts-stream":"c56aef70","vendors~mena-list~speakers-bureau-presentations":"31d6cfe0","mena-list":"a001d7da","speakers-bureau-presentations":"820e6810","admin-settings-panel":"6a6bbd5f","un-antisemitism-speakers":"31d6cfe0","un-antisemitism-stream":"3d04d8d4","vendors~communities":"91f92468","communities":"aab13e47","vendors~driver":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://dxanokv0vp6kj.cloudfront.net/packs/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = "./app/javascript/packs/application.js");
